export const nowVoucher = 'nowpremium'
